import { useTranslation } from "react-i18next";
import { ChatStore } from "@/stores/ChatStore";
import { validateRequired, validateFormat } from "@/lib/validation";

export const useAddressInput = () => {
  const { t } = useTranslation();
  const user = ChatStore(state => state.user);
  const setUser = ChatStore(state => state.setUser);
  const errors = ChatStore(state => state.userInfoFormErrors);
  const setError = ChatStore(state => state.setUserInfoFormError);

  const handleRequiredValidation = (field: string, value: string) => {
    const error = validateRequired(field, value, t);
    setError(field, error);
  };

  const handleFormatValidation = (field: string, value: string) => {
    const requiredError = validateRequired(field, value, t);
    if (!requiredError) {
      const formatError = validateFormat(field, value, t);
      setError(field, formatError);
    }  };

  const handleChange = (field: "street" | "houseNumber" | "postCode" | "city", value: string) => {
    if (user) {
      setUser({
        ...user,
        address: { ...user.address, [field]: value }
      });
    }
    handleRequiredValidation(field, value);
  };

  const handleBlur = (field: string, value: string) => {
    handleFormatValidation(field, value);
  };

  return {
    user,
    errors,
    t,
    handleChange,
    handleBlur
  };
};
